<div
  class="simple-text"
  [style.marginTop.px]="marginService.getCurrentMargin(margin)"
>
  <div class="description" [innerHTML]="descriptionHtml"></div>
</div>
